import * as closedCaptionsActions from './closedCaptionsActions'

export default closedCaptionsActions